import React from "react";

class RouteProfile extends React.Component {
	render() {
		const current = this.props.currentJourney.currentJourney;
		if (this.props.cycleRoutes[current]) {
			this.props.cycleRoutes[current].routeProfile.sort((a, b) => {
				if (a.name === 'Dismount') return 1;
				if (b.name === 'Dismount') return -1;
				return 0;
			});
		}
		return this.props.currentJourney.currentJourney &&
			this.props.cycleRoutes.gotData ? (
			<div className="route-profile">
				<h3 className="route-profile-title">Route profile</h3>
				<ul className="route-profile-list">
					{ this.props.cycleRoutes[current].routeProfile.map((item, i) => (
						<RouteProfileItem item={ item } key={ i } />
					)) }
				</ul>
			</div>
		) : null;
	}
}

/**
 * -RouteProfileItem-
 * Presentational component for each provision (road type) of the current route profile
 **/
const RouteProfileItem = ({ item }) => {
	return (

		<li className="route-profile-list-item">
			<div
				className="profile-indicator"
				style={{ backgroundColor: item.color }}
			></div>
			{item.name !== 'Dismount'  && <span className="profile-percentage">{item.percentage}%</span>}
			<span className="profile-category">{item.name}</span>
		</li>
	)
};

export default RouteProfile;



// WEBPACK FOOTER //
// ./src/components/RouteProfile.js